import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  personalAccounts: null,
  tradeAccounts: null,
  demoAccounts: null,
  pammAccounts: null,

  personalAccountsLoadingStatus: 'idle',
  tradeAccountsLoadingStatus: 'idle',
  pammAccountsLoadingStatus: 'idle',
  demoAccountsLoadingStatus: 'idle',

  tradeAccGroups: null,
  createdTradeAccount: {},
  createTradeAccStatus: '',
  updateTradeAccPasswordStatus: '',

  demoAccGroups: null,
  createdDemoAccount: {},
  createDemoAccStatus: '',
  depositDemoAccStatus: '',

  personalAccGroups: null,
  createdPersonalAccount: {},
  createPersonalAccStatus: '',
};

export const accountsSlice = createSlice({
  name: 'accounts',
  initialState,
  reducers: {
    setTradeAccounts: (state, action) => {
      state.tradeAccounts = action.payload;
    },
    setPammAccounts: (state, action) => {
      state.pammAccounts = action.payload;
    },
    setDemoAccounts: (state, action) => {
      state.demoAccounts = action.payload;
    },
    setPersonalAccounts: (state, action) => {
      state.personalAccounts = action.payload;
    },

    setTradeAccountsLoadingStatus: (state, action) => {
      state.tradeAccountsLoadingStatus = action.payload;
    },
    setPammAccountsLoadingStatus: (state, action) => {
      state.pammAccountsLoadingStatus = action.payload;
    },
    setDemoAccountsLoadingStatus: (state, action) => {
      state.demoAccountsLoadingStatus = action.payload;
    },
    setPersonalAccountsLoadingStatus: (state, action) => {
      state.personalAccountsLoadingStatus = action.payload;
    },

    setTradeAccGroups: (state, action) => {
      state.tradeAccGroups = action.payload;
    },
    setCreatedTradeAccount: (state, action) => {
      state.createdTradeAccount = action.payload;
    },
    setCreateTradeAccStatus: (state, action) => {
      state.createTradeAccStatus = action.payload;
    },
    setUpdateTradeAccPasswordStatus: (state, action) => {
      state.updateTradeAccPasswordStatus = action.payload;
    },

    setDemoAccGroups: (state, action) => {
      state.demoAccGroups = action.payload;
    },
    setCreatedDemoAccount: (state, action) => {
      state.createdDemoAccount = action.payload;
    },
    setCreateDemoAccStatus: (state, action) => {
      state.createDemoAccStatus = action.payload;
    },
    setDepositdDemoAccStatus: (state, action) => {
      state.depositDemoAccStatus = action.payload;
    },

    setPersonalAccGroups: (state, action) => {
      state.personalAccGroups = action.payload;
    },
    setCreatedPersonalAccount: (state, action) => {
      state.createdPersonalAccount = action.payload;
    },
    setCreatePersonalAccStatus: (state, action) => {
      state.createPersonalAccStatus = action.payload;
    },

    resetAccounts: () => initialState,
  },
});

export const {
  setTradeAccounts,
  setPammAccounts,
  setDemoAccounts,
  setPersonalAccounts,

  setTradeAccountsLoadingStatus,
  setPammAccountsLoadingStatus,
  setDemoAccountsLoadingStatus,
  setPersonalAccountsLoadingStatus,

  setTradeAccGroups,
  setCreatedTradeAccount,
  setCreateTradeAccStatus,
  setUpdateTradeAccPasswordStatus,

  setDemoAccGroups,
  setCreatedDemoAccount,
  setCreateDemoAccStatus,
  setDepositdDemoAccStatus,

  setPersonalAccGroups,
  setCreatedPersonalAccount,
  setCreatePersonalAccStatus,

  resetAccounts,
} = accountsSlice.actions;

export default accountsSlice.reducer;
